import { API_PALLAS_APPS_URL } from "../ducks/consts";
import timeoutError from "../utils/timeoutError";

// O fetch não tem timeout: uma requisição presa (rede ruim, app em segundo
// plano) travava o polling da tela de status até o navegador desistir. O
// timeout cobre a resposta inteira, corpo incluído: só nos cabeçalhos, um corpo
// que não chega prendia o polling do mesmo jeito. São 30s porque a rota é
// barata, mas no pico espera conexão do pool do banco (o nginx espera até
// 120s): cortar antes descartava a resposta que ia chegar.
export const TIMEOUT_MS = 30000;

async function buscarStatus(orderId, signal) {
  const response = await fetch(
    `${API_PALLAS_APPS_URL}/pedido/${orderId}/status`,
    { signal },
  );
  if (!response.ok) {
    throw new Error("No 2XX response, left unhandled.");
  }

  const json = await response.json();
  if (!json || !Array.isArray(json)) {
    throw new Error("Unknown JSON response.");
  }

  return json;
}

const RemoteOrder = {
  retrieveStatus: async (orderId) => {
    // O AbortController só existe do Chrome 66 em diante, e WebView antigo de
    // POS e totem pode não ter. Sem ele o timeoutError ainda garante que a
    // promessa termina; só a requisição vencida fica pendurada.
    const controle =
      typeof AbortController === "function" ? new AbortController() : null;
    try {
      return await timeoutError(
        TIMEOUT_MS,
        buscarStatus(orderId, controle ? controle.signal : undefined),
      );
    } finally {
      // libera a requisição que venceu; com a resposta já lida, não faz nada
      if (controle) controle.abort();
    }
  },
};

export default RemoteOrder;
